import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from './auth.service';

/**
 * Aggiunge il bearer token e l'header di client; su 401 tenta UN refresh silenzioso e ripete la richiesta.
 * Se il refresh fallisce la sessione e' scaduta: si torna al login.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith('/api/')) {
    return next(req);
  }
  const auth = inject(AuthService);
  const router = inject(Router);
  const isAuthCall = req.url.includes('/api/v1/auth/');

  const withAuth = (token: string | null) =>
    req.clone({
      setHeaders: {
        'X-Guerra-Client': 'web',
        ...(token && !isAuthCall ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

  return next(withAuth(auth.accessToken())).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401 || isAuthCall) {
        return throwError(() => error);
      }
      return auth.refresh().pipe(
        switchMap((token) => next(withAuth(token))),
        catchError((refreshError) => {
          auth.clearSession();
          void router.navigate(['/login'], { queryParams: { returnUrl: router.url, expired: 1 } });
          return throwError(() => refreshError instanceof HttpErrorResponse ? error : refreshError);
        }),
      );
    }),
  );
};
